import { NotificationVariant } from '../types/notification.types';
import { IconSet } from '../types/icon.types';

export interface NotificationConfig {
  title: string;
  description: string;
  variant: NotificationVariant;
  iconset: IconSet;
  duration?: number;
  dismissable?: boolean;
}

export class NotificationConfigBuilder {
  config: NotificationConfig = {
    title: '',
    description: '',
    variant: 'info',
    iconset: 'basic',
    duration: 5000,
    dismissable: true,
  };

  title(title: string): this {
    this.config.title = title;
    return this;
  }

  description(description: string): this {
    this.config.description = description;
    return this;
  }

  variant(variant: NotificationVariant): this {
    this.config.variant = variant;
    return this;
  }

  iconset(iconset: IconSet): this {
    this.config.iconset = iconset;
    return this;
  }

  duration(duration: number): this {
    this.config.duration = duration;
    return this;
  }

  dismissable(dismissable: boolean): this {
    this.config.dismissable = dismissable;
    return this;
  }

  build(): NotificationConfig {
    return this.config;
  }
}
